import { Action } from '@ngrx/store';
import { ICarousel } from 'src/app/models/carousel.interface';
import { IFreebet } from 'src/app/models/freebet.interface';
import {IPlayremainders} from '../../models/playremainders.interface';
import {IFavorites} from '../../models/favorites';
import {IErrorRequest} from '../../models/error.interface';

export enum EPageActions {
  PageLoadingHide = '[Page] Hide Loading',
  PageLoadingShow = '[Page] Show Loading',
  PageLoadingMenuHide = '[Page] Hide Loading Menu',
  PageLoadingMenuShow = '[Page] Show Loading Menu',
  PagePlaceSelect = '[Page] Select Place',
  PagePlaceSelectStart = '[Page] Select Place Start',
  PageFullSreen = '[Page] Toggle Full Screen',
  PageShowMenu = '[Page] Show Menu',
  PageShowCart = '[Page] Show Cart',
  PageShowLast = '[Page] Show Last',
  PageShowBonus = '[Page] Show Bonus',
  PageAddSession = '[Page] Add Session',
  PageAddCID = '[Page] Add CID',
  PageAddFirstStreaming = '[Page] Add First Streaming',
  PageGetIp = '[Page] Get Ip',
  PageGetIpSuccess = '[Page] Get Ip Success',
  PageAddLogo = '[Page] Add Logo',
  PageAddImagesHome = '[Page] Add Images Home',
  PageAddImagesCart = '[Page] Add Images Cart',
  PageAddTrackGA = '[Page] Add TrackGA',
  PageAddVideoEnabled = '[Page] Add VideoEnabled',
  PageAddDisableAudio = '[Page] Add DisableAudio',
  PageAddPlayVideo = '[Page] Add Play Video',
  PageAddShowTicketList = '[Page] Add Show Ticket List',
  PageAddFunctionCompleteBet = '[Page] Add Function Complete Bet',
  PageAddFunctionButtonBet = '[Page] Add Function Click Bet not loged',
  PageSetCartTabIndex = '[Page] Set Tab Cart Index',
  PageSetMenuTabIndex = '[Page] Set Tab Menu Index',
  PageSetCountryMenu = '[Page] Set Country Menu',
  PageSetTypeMenu = '[Page] Set Type Menu',
  PageSetSystemBetMenu = '[Page] Set System Bet Menu',
  PageSetFreebetSingle = '[Page] Set Freebet Single',
  PageSetFreebetMultiple = '[Page] Set Freebet Multiple',
  PageSetFreebetSystem = '[Page] Set Freebet System',
  PageSetBonusSingle = '[Page] Set Bonus Single',
  PageSetBonusMultiple = '[Page] Set Bonus Multiple',
  PageSetBonusSystem = '[Page] Set Bonus System',
  PageSetPlayerRace = '[Page] Set Player Race',
  PageSetCountRaceMenu = '[Page] Set Count type race',
  PageReminderBets = '[Page] Set reminder bets',
  PageReminderBetsSuccess = '[Page] reminder bets success',
  PageReminderBetsReset = '[Page] reminder bets reset',
  PageSetOpenRace = '[Page] set view only race open',
  PageSetOpenNoOddRace = '[Page] set view only race open no odd',
  PageSetCloseRace = '[Page] set view only race close',
  PageSetFavorite = '[Page] set favorite nation page menu',
  PageSetHidefullstats = '[Page] set Hide Stats',
  PageSetTerminalTag = '[Page] set Terimanl tag number',
  PageErrorPage = '[Page] set error request page',
  PageConfirmBetState = '[Page] set confirm bet',
  PageCoverVideo = '[Page] set url cover video',
  PageToday = '[Page] today set'
}

export class PageLoadingHide implements Action {
  public readonly type = EPageActions.PageLoadingHide;
}

export class PageLoadingShow implements Action {
  public readonly type = EPageActions.PageLoadingShow;
}

export class PageLoadingMenuHide implements Action {
  public readonly type = EPageActions.PageLoadingMenuHide;
}

export class PageLoadingMenuShow implements Action {
  public readonly type = EPageActions.PageLoadingMenuShow;
}

export class PagePlaceSelect implements Action {
  public readonly type = EPageActions.PagePlaceSelect;
  constructor(public payload: string) {}
}

export class PagePlaceSelectStart implements Action {
  public readonly type = EPageActions.PagePlaceSelectStart;
  constructor(public payload: string) {}
}

export class PageFullSreen implements Action {
  public readonly type = EPageActions.PageFullSreen;
}

export class PageShowMenu implements Action {
  public readonly type = EPageActions.PageShowMenu;
  constructor(public payload?: boolean) {}
}

export class PageShowCart implements Action {
  public readonly type = EPageActions.PageShowCart;
}

export class PageShowLast implements Action {
  public readonly type = EPageActions.PageShowLast;
}

export class PageShowBonus implements Action {
  public readonly type = EPageActions.PageShowBonus;
}

export class PageAddSession implements Action {
  public readonly type = EPageActions.PageAddSession;
  constructor(public payload: string) {}
}

export class PageAddCID implements Action {
  public readonly type = EPageActions.PageAddCID;
  constructor(public payload: string) {}
}

export class PageAddFirstStreaming implements Action {
  public readonly type = EPageActions.PageAddFirstStreaming;
  constructor(public payload: any) {}
}

export class PageSetPlayerRace implements Action {
  public readonly type = EPageActions.PageSetPlayerRace;
  constructor(public payload: any) {}
}

export class PageGetIp implements Action {
  public readonly type = EPageActions.PageGetIp;
}

export class PageGetIpSuccess implements Action {
  public readonly type = EPageActions.PageGetIpSuccess;
  constructor(public payload: any) {}
}

export class PageAddLogo implements Action {
  public readonly type = EPageActions.PageAddLogo;
  constructor(public payload: string) {}
}

export class PageAddImagesHome implements Action {
  public readonly type = EPageActions.PageAddImagesHome;
  constructor(public payload: ICarousel[]) {}
}

export class PageAddImagesCart implements Action {
  public readonly type = EPageActions.PageAddImagesCart;
  constructor(public payload: ICarousel[]) {}
}

export class PageAddTrackGA implements Action {
  public readonly type = EPageActions.PageAddTrackGA;
  constructor(public payload: string) {}
}

export class PageAddVideoEnabled implements Action {
  public readonly type = EPageActions.PageAddVideoEnabled;
  constructor(public payload: boolean) {}
}

export class PageAddPlayVideo implements Action {
  public readonly type = EPageActions.PageAddPlayVideo;
  constructor(public payload: boolean) {}
}

export class PageAddDisableAudio implements Action {
  public readonly type = EPageActions.PageAddDisableAudio;
  constructor(public payload: boolean) {}
}

export class PageAddShowTicketList implements Action {
  public readonly type = EPageActions.PageAddShowTicketList;
  constructor(public payload: boolean) {}
}

export class PageAddFunctionCompleteBet implements Action {
  public readonly type = EPageActions.PageAddFunctionCompleteBet;
  constructor(public payload: string) {}
}

export class PageAddFunctionButtonBet implements Action {
  public readonly type = EPageActions.PageAddFunctionButtonBet;
  constructor(public payload: string) {}
}

export class PageSetCartTabIndex implements Action {
  public readonly type = EPageActions.PageSetCartTabIndex;
  constructor(public payload: number) {}
}

export class PageSetMenuTabIndex implements Action {
  public readonly type = EPageActions.PageSetMenuTabIndex;
  constructor(public payload: number) {}
}

export class PageSetCountryMenu implements Action {
  public readonly type = EPageActions.PageSetCountryMenu;
  constructor(public payload: number) {}
}

export class PageSetTypeMenu implements Action {
  public readonly type = EPageActions.PageSetTypeMenu;
  constructor(public payload: string) {}
}
export class PageSetSystemBetMenu implements Action {
  public readonly type = EPageActions.PageSetSystemBetMenu;
  constructor(public payload: string) {}
}

export class PageSetOpenRace implements Action {
  public readonly type = EPageActions.PageSetOpenRace;
  constructor(public payload: boolean) {}
}

export class PageSetOpenNoOddRace implements Action {
  public readonly type = EPageActions.PageSetOpenNoOddRace;
  constructor(public payload: boolean) {}
}

export class PageSetCloseRace implements Action {
  public readonly type = EPageActions.PageSetCloseRace;
  constructor(public payload: boolean) {}
}

export class PageSetFreebetSingle implements Action {
  public readonly type = EPageActions.PageSetFreebetSingle;
  constructor(public payload: IFreebet) {}
}

export class PageSetFreebetMultiple implements Action {
  public readonly type = EPageActions.PageSetFreebetMultiple;
  constructor(public payload: IFreebet) {}
}

export class PageSetFreebetSystem implements Action {
  public readonly type = EPageActions.PageSetFreebetSystem;
  constructor(public payload: IFreebet) {}
}

export class PageSetBonusSingle implements Action {
  public readonly type = EPageActions.PageSetBonusSingle;
  constructor(public payload: boolean) {}
}

export class PageSetBonusMultiple implements Action {
  public readonly type = EPageActions.PageSetBonusMultiple;
  constructor(public payload: boolean) {}
}

export class PageSetBonusSystem implements Action {
  public readonly type = EPageActions.PageSetBonusSystem;
  constructor(public payload: boolean) {}
}

export class PageSetCountRaceMenu implements Action {
  public readonly type = EPageActions.PageSetCountRaceMenu;
  constructor(public payload: any) {}
}

export class PageReminderBets implements Action {
  public readonly type = EPageActions.PageReminderBets;
  constructor(public session: string, public race: number, public events: boolean) {
  }
}

export class PageReminderBetsSuccess implements Action {
  public readonly type = EPageActions.PageReminderBetsSuccess;
  constructor(public payload: IPlayremainders, public events: boolean) {}
}

export class PageReminderBetsReset implements Action {
  public readonly type = EPageActions.PageReminderBetsReset;
  constructor() {}
}

export class PageSetFavorite implements Action {
  public readonly type = EPageActions.PageSetFavorite;
  constructor(public payload: IFavorites[]) {}
}

export class PageSetHidefullstats implements Action {
  public readonly type = EPageActions.PageSetHidefullstats;
  constructor(public payload: boolean) {}
}

export class PageSetTerminalTag implements Action {
  public readonly type = EPageActions.PageSetTerminalTag;
  constructor(public payload: number) {}
}

export class PageErrorPage implements Action {
  public readonly type = EPageActions.PageErrorPage;
  constructor(public payload: IErrorRequest) {}
}

export class PageConfirmBetState implements Action {
  public readonly type = EPageActions.PageConfirmBetState;
  constructor(public payload: boolean) {}
}

export class PageCoverVideo implements Action {
  public readonly type = EPageActions.PageCoverVideo;
  constructor(public payload: string) {}
}

export class PageToday implements Action {
  public readonly type = EPageActions.PageToday;
  constructor(public payload: boolean) {}
}



export type PageActions =
  | PageLoadingHide
  | PageLoadingShow
  | PageLoadingMenuHide
  | PageLoadingMenuShow
  | PagePlaceSelect
  | PagePlaceSelectStart
  | PageFullSreen
  | PageShowMenu
  | PageShowCart
  | PageAddSession
  | PageAddCID
  | PageAddFirstStreaming
  | PageGetIp
  | PageGetIpSuccess
  | PageAddLogo
  | PageAddImagesHome
  | PageAddImagesCart
  | PageAddTrackGA
  | PageAddVideoEnabled
  | PageAddPlayVideo
  | PageAddDisableAudio
  | PageAddShowTicketList
  | PageAddFunctionCompleteBet
  | PageAddFunctionButtonBet
  | PageSetCartTabIndex
  | PageSetMenuTabIndex
  | PageSetCountryMenu
  | PageSetTypeMenu
  | PageSetSystemBetMenu
  | PageSetFreebetSingle
  | PageSetFreebetMultiple
  | PageSetFreebetSystem
  | PageSetBonusSingle
  | PageSetBonusMultiple
  | PageSetPlayerRace
  | PageSetBonusSystem
  | PageSetCountRaceMenu
  | PageReminderBets
  | PageReminderBetsSuccess
  | PageReminderBetsReset
  | PageSetOpenRace
  | PageSetOpenNoOddRace
  | PageSetCloseRace
  | PageSetFavorite
  | PageShowLast
  | PageShowBonus
  | PageSetHidefullstats
  | PageSetTerminalTag
  | PageConfirmBetState
  | PageCoverVideo
  | PageErrorPage
  | PageToday;
